import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import {
  InvestigationAdvertisement,
  InvestigationSectionHeader,
  Separator,
} from "../components";
import { patchInvestigation } from "../../../../../apis";
import { useConstants } from "../Main/useConstants";
import {
  isFinancialImpactEmpty,
  normalizeFinancialImpact,
  serializeFinancialImpact,
} from "../../../../../helpers/financialImpact";
import { AddFinancialImpact } from "./AddFinancialImpact";
import { SingleFinancialImpact } from "./SingleFinancialImpact";

/**
 * Seccion "Impacto financiero": los montos del quebranto y las cuentas
 * afectadas o beneficiarias. Se llena a mano y solo aplica a los casos con
 * perdida economica, tipicamente fraude.
 */
export const FinancialImpact = ({
  investigation,
  setInvestigation,
  justView = false,
  handleSelectedSection,
  onReload,
}) => {
  const [t] = useTranslation("investigation");
  const { enums } = useConstants();

  const [financialImpact, setFinancialImpact] = useState(() =>
    normalizeFinancialImpact(investigation.financial_impact)
  );
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setFinancialImpact(
      normalizeFinancialImpact(investigation.financial_impact)
    );
  }, [investigation?.financial_impact]);

  const someImpactExist = !isFinancialImpactEmpty(financialImpact);

  const handleSave = async (newImpact) => {
    setIsLoading(true);
    const serialized = serializeFinancialImpact(newImpact);
    try {
      await patchInvestigation(investigation.alias, {
        folder: { financial_impact: serialized },
      });
      setInvestigation((prev) => ({ ...prev, financial_impact: serialized }));
      setIsEditing(false);
      onReload();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box className="dyTheme1" p={1}>
      {!isEditing && !justView && (
        <InvestigationSectionHeader
          text={t("financialImpact.add_financial_impact_to_investigation")}
          buttonText={
            someImpactExist
              ? t("financialImpact.edit_financial_impact_btn")
              : t("financialImpact.add_financial_impact_btn")
          }
          buttonIcon="outline_money_4"
          onClick={() => setIsEditing(true)}
        />
      )}

      {justView && (
        <Separator
          text={t("sections.financial_impact")}
          icon="outline_money_4"
          iconButton={handleSelectedSection ? "outline_edit" : undefined}
          onClick={
            handleSelectedSection
              ? () => handleSelectedSection(enums.sections.financialImpact)
              : undefined
          }
          sx={{ marginBottom: 1.5 }}
        />
      )}

      {!someImpactExist && !isEditing && (
        <InvestigationAdvertisement
          title={t("financialImpact.no_financial_impact_loaded")}
          description={t("financialImpact.no_financial_impact_loaded_description")}
        />
      )}

      {someImpactExist && !isEditing && (
        <SingleFinancialImpact
          financialImpact={financialImpact}
          setIsEditing={setIsEditing}
          justView={justView}
        />
      )}

      {isEditing && (
        <AddFinancialImpact
          financialImpact={financialImpact}
          setIsEditing={setIsEditing}
          handleSave={handleSave}
          isLoading={isLoading}
        />
      )}
    </Box>
  );
};
